<template>
  <Modal is-overflow-visible open @close="handleCloseButtonClick">
    <div class="relative">
      <button
        class="absolute -right-4 -top-4 flex p-2"
        @click="handleCloseButtonClick"
      >
        <Icon name="close" class="text-xl text-zinc-800" />
      </button>

      <span class="mb-4 block text-xl font-medium">{{ __('Change job') }}</span>

      <form
        class="space-y-4"
        @submit.prevent="handleSubmit(requisition, close)"
      >
        <ul class="my-2 ml-4 list-disc space-y-2">
          <li>
            <label class="text-zinc-800">{{ __('Nr. IQHR') }}:</label>
            {{ requisition.id_iqhr }}
          </li>
          <li>
            <label class="text-zinc-800">{{ __('Position') }}:</label>
            {{ requisition.role }}
          </li>
          <li>
            <label class="text-zinc-800">{{ __('Position code') }}:</label>
            {{ requisition.position_code }}
          </li>
          <li>
            <label class="text-zinc-800">{{ __('Initiator') }}:</label>
            {{ requisition.ic_name }}
          </li>
          <li>
            <label class="text-zinc-800">{{ __('Division') }}:</label>
            {{ requisition.division }}
          </li>
          <li>
            <label class="text-zinc-800">{{ __('Location') }}:</label>
            {{ requisition.location }}
          </li>
          <li>
            <label class="text-zinc-800">{{ __('Date') }}:</label>
            {{ requisition.created_at }}
          </li>
        </ul>

        <div class="flex justify-center">
          <Button
            class="flex items-center gap-1.5 justify-self-center"
            type="submit"
            :disabled="isLoading"
          >
            <Icon
              v-if="isLoading"
              class="animate-spin text-lg"
              name="progress_activity"
            />
            <span>{{ __('Change') }}</span>
          </Button>
        </div>
      </form>
    </div>
  </Modal>
</template>

<script setup>
  import { onMounted, ref } from 'vue';
  import { useToast } from 'vue-toastification';
  import { __ } from '@/helpers';
  import { Button } from '@/components/block/button';
  import { Icon } from '@/components/block/icon';
  import { Modal } from '@/components/block/modal';
  import { InputSelect } from '@/components/form/input-select';

  const props = defineProps({
    requisition: {
      type: Object,
      required: true
    },
    requisitions: {
      type: Array,
      default: () => []
    },
  });

  const emits = defineEmits(['update', 'close']);

  const toast = useToast();

  const values = ref({ parent_job: null });
  const errors = ref({ parent_job: [] });
  const isLoading = ref(false);

  function handleCloseButtonClick() {
    emits('close');
  }

  async function handleSubmit() {
    Object.keys(values.value).forEach((key) => {
      if (!values.value[key]) {
        errors.value[key] = [__('This field is required')];
      }
    });

    if (Object.values(errors.value).some((error) => error.length)) {
      return;
    }

    isLoading.value = true;

    try {
      const response = await axios.post(
        route('redesign.company.requisitions.update', props.requisition.id),
        { parent_id: values.value.parent_job.id }
      );

      if (response?.data?.message) {
        toast.success(response.data.message);
      }

      const updatedRequisition = response.data.data;

      emits(
        'update',
        props.requisitions.map((req) => {
          if (req.id === updatedRequisition.id) {
            return updatedRequisition;
          }

          return req;
        })
      );
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error(
          __('An unexpected error has occured. Please try again later.')
        );
      }
    }

    isLoading.value = false;
  }

  onMounted(() => {
    values.value.parent_job = [];
  });
</script>
